import Spinners from "components/common/Spinners";
import { formatDate } from "components/common/Utils";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getRewardSettingList } from "store/actions/couponAction";

const RewardCard = ({ className = "" }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { loading, rewardSettingList } = useSelector((state) => state.Coupons);

  const [rewardsSettingData, setRewardsSettingData] = useState([]);

  const staticConfig = {
    1: {
      title1: "Rewards Page",
      titleAr1: "Rewards Page",
      redirectLink: "/rewards/rewards-page",
    },
    2: {
      title1: "Cashback",
      titleAr1: "Cashback",
      redirectLink: "/rewards/cashback",
    },
    3: {
      title1: "Referral Code",
      titleAr1: "Referral Code",
      redirectLink: "/rewards/referral",
    },
  };

  useEffect(() => {
    dispatch(getRewardSettingList());
  }, []);

  useEffect(() => {
    if (!loading && rewardSettingList?.length > 0) {
      const mergedRewardsData = rewardSettingList.map((item) => {
        const staticInfo = staticConfig[item.id] || {};

        return {
          ...item,
          lastUpdatedOn: formatDate(item.lastUpdatedOn),
          editedBy: item.editedBy?.name || "",
          ...staticInfo,
        };
      });
      setRewardsSettingData(mergedRewardsData);
    }
  }, [rewardSettingList]);

  return (
    <Row>
      {loading ? (
        <Spinners />
      ) : (
        rewardsSettingData?.map((item, index) => (
          <Col lg={4} key={index}>
            <div
              className={`top_card_inner_section c_p ${className}`}
              onClick={() => navigate(item?.redirectLink)}
            >
              <div className="content">
                <h2>{item?.title}</h2>
                <div className="g_between bottom_div">
                  <p>
                    <span>{t("Last Edit on")}</span>: {item?.lastUpdatedOn} by{" "}
                    <span>{item?.editedBy}</span>
                  </p>
                </div>
              </div>
            </div>
          </Col>
        ))
      )}
    </Row>
  );
};

export default RewardCard;
